import { render, staticRenderFns } from "./StandardPagination.vue?vue&type=template&id=82c93f6a&scoped=true"
import script from "./StandardPagination.vue?vue&type=script&lang=js"
export * from "./StandardPagination.vue?vue&type=script&lang=js"
import style0 from "./StandardPagination.vue?vue&type=style&index=0&id=82c93f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c93f6a",
  null
  
)

export default component.exports